import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Mechanics from "./components/Mechanics";
import CategoryMap from "./components/CategoryMap";
import HotRank from "./components/HotRank";
import Feed from "./components/Feed";
import Praise from "./components/Praise";
import Faq from "./components/Faq";
import About from "./components/About";
import Subscribe from "./components/Subscribe";
import Footer from "./components/Footer";

function BackToTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  if (!show) return null;
  return (
    <button
      onClick={scrollTop}
      aria-label="返回顶部"
      className="fixed bottom-6 right-6 z-50 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-md transition-colors hover:bg-primary-600"
    >
      <i className="ri-arrow-up-line text-lg"></i>
    </button>
  );
}

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Mechanics />
        <CategoryMap />
        <HotRank />
        <Feed />
        <Praise />
        <Faq />
        <About />
        <Subscribe />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}